module.exports = __webpack_public_path__ + "media/icons/bell-b5c13af2.png";